/* AuraSupps — shared behaviour for the aura-pdp-* product sections.
   Extracted from the old monolithic aura-product*.liquid files. The original
   scoped every query to a single .aura-pdp container; now each section is its
   own .aura-pdp wrapper, so everything runs against the document and is
   idempotent + re-runs on shopify:section:load for the theme editor. */
(function () {
  if (window.__auraPdp) return;
  window.__auraPdp = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function once(el, key) {
    if (el.hasAttribute(key)) return false;
    el.setAttribute(key, '1');
    return true;
  }

  /* ---------- reveal ---------- */
  var io = null;
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
    }
    document.querySelectorAll('.aura-pdp .reveal:not([data-pdp-seen])').forEach(function (el) {
      el.setAttribute('data-pdp-seen', '1');
      io.observe(el);
    });
  }

  /* ---------- header: mobile menu ---------- */
  function initNav() {
    document.querySelectorAll('.aura-pdp .nav').forEach(function (navBar) {
      if (!once(navBar, 'data-pdp-nav')) return;
      var burger = navBar.querySelector('.nav-burger');
      if (!burger) return;
      burger.addEventListener('click', function () {
        var open = navBar.classList.toggle('menu-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      navBar.querySelectorAll('menu a').forEach(function (a) {
        a.addEventListener('click', function () {
          navBar.classList.remove('menu-open');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery() {
    document.querySelectorAll('.aura-pdp .thumbs').forEach(function (thumbs) {
      if (!once(thumbs, 'data-pdp-gal')) return;
      var scope = thumbs.closest('.gallery') || document;
      var mainImg = scope.querySelector('#mainImg') || document.getElementById('mainImg');
      thumbs.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          if (mainImg) mainImg.src = b.getAttribute('data-full');
        });
      });
    });
  }

  /* ---------- tabs + benefits toggle ---------- */
  function initTabs() {
    document.querySelectorAll('.aura-pdp .tabs').forEach(function (tabs) {
      if (!once(tabs, 'data-pdp-tabs')) return;
      var box = tabs.closest('.buybox') || document;
      tabs.querySelectorAll('.tab').forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.querySelectorAll('.tab').forEach(function (x) { x.classList.remove('active'); });
          t.classList.add('active');
          box.querySelectorAll('.tabpane').forEach(function (p) {
            p.classList.toggle('active', p.getAttribute('data-pane') === t.getAttribute('data-tab'));
          });
        });
      });
    });

    document.querySelectorAll('.aura-pdp .seeben').forEach(function (sb) {
      if (!once(sb, 'data-pdp-ben')) return;
      var bl = sb.parentElement.querySelector('.benlist');
      if (!bl) return;
      var openLabel = sb.getAttribute('data-open') || 'Скрий ползите −';
      var shutLabel = sb.getAttribute('data-shut') || 'Виж ползите +';
      sb.addEventListener('click', function () {
        if (bl.hasAttribute('hidden')) { bl.removeAttribute('hidden'); sb.textContent = openLabel; }
        else { bl.setAttribute('hidden', ''); sb.textContent = shutLabel; }
      });
    });
  }

  /* ---------- offer tiers + add to cart ---------- */
  var selPack = null;
  function applyTier(p) {
    var pay = parseInt(p.getAttribute('data-pay'), 10);
    var reg = parseInt(p.getAttribute('data-reg'), 10);
    var qty = parseInt(p.getAttribute('data-qty'), 10);
    var pnow = document.querySelector('.aura-pdp .pnow');
    var pold = document.querySelector('.aura-pdp .pold');
    var gnote = document.querySelector('.aura-pdp .gift-note');
    var btnp = document.querySelector('.aura-pdp .btnp');
    var sprice = document.querySelector('.aura-pdp .sprice');
    if (pnow) pnow.textContent = money(pay);
    if (pold) { if (reg > pay) { pold.textContent = money(reg); pold.hidden = false; } else { pold.hidden = true; } }
    if (gnote) { if (qty > 1) { gnote.textContent = qty + ' ' + (gnote.getAttribute('data-word') || 'кутии'); gnote.hidden = false; } else { gnote.hidden = true; } }
    if (btnp) btnp.textContent = money(pay);
    if (sprice) sprice.textContent = money(pay);
  }
  function initPacks() {
    var packs = document.querySelectorAll('.aura-pdp .pack');
    if (!packs.length) return;
    selPack = document.querySelector('.aura-pdp .pack.sel') || packs[0];
    packs.forEach(function (p) {
      if (!once(p, 'data-pdp-pack')) return;
      p.addEventListener('click', function () {
        document.querySelectorAll('.aura-pdp .pack').forEach(function (x) { x.classList.remove('sel'); });
        p.classList.add('sel');
        selPack = p;
        applyTier(p);
      });
    });
    if (selPack) applyTier(selPack);
  }

  function openDrawer() {
    if (window.auraOpenCart) { window.auraOpenCart(); return; }
    var d = document.querySelector('cart-drawer');
    if (d) { d.classList.add('aura-open', 'active', 'animate'); }
    else { window.location.href = ROOT + 'cart'; }
  }
  function applySections(s) {
    if (s['cart-drawer']) {
      var p = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
      var ni = p.querySelector('.drawer__inner');
      var d = document.querySelector('cart-drawer');
      var ci = d ? d.querySelector('.drawer__inner') : null;
      if (ni && ci) ci.replaceWith(ni);
      if (d) d.classList.remove('is-empty');
    }
    if (s['cart-icon-bubble']) {
      var live = document.getElementById('cart-icon-bubble');
      if (live) {
        var rd = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var sx = rd.getElementById('cart-icon-bubble');
        if (sx) live.innerHTML = sx.innerHTML;
      }
    }
  }
  function updateCount() {
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.aura-pdp .cart .cn').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }
  function addItems(items, btn) {
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.style.opacity = '.6'; btn.disabled = true; }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (btn) { btn.style.opacity = ''; btn.disabled = false; if (label) btn.innerHTML = label; }
        if (!data || data.status) return;
        applySections(data.sections || {});
        updateCount();
        openDrawer();
      })
      .catch(function () { if (btn) { btn.style.opacity = ''; btn.disabled = false; } });
  }
  function addMain(btn) {
    var addBtn = document.querySelector('.aura-pdp .addbag');
    var vid = addBtn ? parseInt(addBtn.getAttribute('data-aura-add'), 10) : 0;
    if (!vid) return;
    var qty = selPack ? parseInt(selPack.getAttribute('data-qty'), 10) : 1;
    addItems([{ id: vid, quantity: qty || 1 }], btn);
  }
  function initCart() {
    document.querySelectorAll('.aura-pdp .addbag').forEach(function (b) {
      if (once(b, 'data-pdp-add')) b.addEventListener('click', function () { addMain(b); });
    });
    document.querySelectorAll('.aura-pdp [data-sticky-add]').forEach(function (b) {
      if (once(b, 'data-pdp-sticky')) b.addEventListener('click', function () { addMain(b); });
    });
    document.querySelectorAll('.aura-pdp .ucard-add').forEach(function (b) {
      if (!once(b, 'data-pdp-up')) return;
      b.addEventListener('click', function () {
        var id = parseInt(b.getAttribute('data-variant'), 10);
        if (id) addItems([{ id: id, quantity: 1 }], b);
      });
    });
  }

  /* ---------- sticky bar ---------- */
  function initSticky() {
    var sticky = document.querySelector('.aura-pdp .sticky');
    var addBtn = document.querySelector('.aura-pdp .addbag');
    if (!sticky || !addBtn || !('IntersectionObserver' in window)) return;
    if (!once(sticky, 'data-pdp-stickyobs')) return;
    new IntersectionObserver(function (es) {
      sticky.classList.toggle('show', !es[0].isIntersecting);
    }, { rootMargin: '0px 0px -8px 0px', threshold: 0 }).observe(addBtn);
  }

  /* ---------- research "show more" ---------- */
  function initResearchToggle() {
    document.querySelectorAll('.aura-pdp .clin-toggle').forEach(function (btn) {
      if (!once(btn, 'data-pdp-clin')) return;
      btn.addEventListener('click', function () {
        var m = btn.previousElementSibling;
        while (m && !m.classList.contains('clin-more')) m = m.previousElementSibling;
        if (!m) return;
        if (m.hasAttribute('hidden')) {
          m.removeAttribute('hidden');
          btn.textContent = btn.getAttribute('data-shut') || 'Скрий ▲';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          m.setAttribute('hidden', '');
          btn.textContent = btn.getAttribute('data-open') || 'Покажи още изследвания ▾';
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ---------- Judge.me reviews: reveal the wrapper only once it renders ---------- */
  function initReviews() {
    var d = document.getElementById('judgeme_product_reviews');
    if (!d) return;
    var s = d.closest('.reviews-sec');
    if (!s || !once(s, 'data-pdp-rev')) return;
    var check = function () { if (d.children.length || d.textContent.trim()) s.style.display = ''; };
    check();
    new MutationObserver(check).observe(d, { childList: true, subtree: true });
  }

  /* ---------- cart badge sync when the drawer changes ---------- */
  function initDrawerSync() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl || !('MutationObserver' in window)) return;
    if (!once(drawerEl, 'data-pdp-sync')) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(updateCount, 250); })
      .observe(drawerEl, { subtree: true, childList: true });
  }

  /* ---------- sparkles ---------- */
  var SNS = 'http://www.w3.org/2000/svg';
  var SD = 'M9.82531 0.843845C10.0553 0.215178 10.9446 0.215178 11.1746 0.843845L11.8618 2.72026C12.4006 4.19229 12.3916 6.39157 13.5 7.5C14.6084 8.60843 16.8077 8.59935 18.2797 9.13822L20.1561 9.82534C20.7858 10.0553 20.7858 10.9447 20.1561 11.1747L18.2797 11.8618C16.8077 12.4007 14.6084 12.3916 13.5 13.5C12.3916 14.6084 12.4006 16.8077 11.8618 18.2798L11.1746 20.1562C10.9446 20.7858 10.0553 20.7858 9.82531 20.1562L9.13819 18.2798C8.59932 16.8077 8.60843 14.6084 7.5 13.5C6.39157 12.3916 4.19225 12.4007 2.72023 11.8618L0.843814 11.1747C0.215148 10.9447 0.215148 10.0553 0.843814 9.82534L2.72023 9.13822C4.19225 8.59935 6.39157 8.60843 7.5 7.5C8.60843 6.39157 8.59932 4.19229 9.13819 2.72026L9.82531 0.843845Z';
  var SCOLS = ['#e3ff74', '#a48fff'];
  function initSparkles() {
    document.querySelectorAll('.aura-pdp .sparkles:not([data-pdp-spk])').forEach(function (el) {
      el.setAttribute('data-pdp-spk', '1');
      var n = parseInt(el.getAttribute('data-spk'), 10) || 7;
      for (var i = 0; i < n; i++) {
        var s = document.createElementNS(SNS, 'svg');
        s.setAttribute('viewBox', '0 0 21 21');
        s.setAttribute('class', 'spk');
        var p = document.createElementNS(SNS, 'path');
        p.setAttribute('d', SD);
        p.setAttribute('fill', SCOLS[Math.random() > 0.5 ? 0 : 1]);
        s.appendChild(p);
        (function (node) {
          function place() {
            node.style.left = (Math.random() * 100) + '%';
            node.style.top = (Math.random() * 100) + '%';
            node.style.setProperty('--s', (Math.random() * 0.9 + 0.4).toFixed(2));
            node.style.animationDelay = (Math.random() * 2).toFixed(2) + 's';
          }
          place();
          node.addEventListener('animationiteration', function () { if (Math.random() > 0.7) place(); });
        })(s);
        el.appendChild(s);
      }
    });
  }

  /* ---------- header cart opener (delegated, document-wide) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('.aura-pdp [data-aura-cart]');
    if (o) { e.preventDefault(); openDrawer(); }
  });

  function init() {
    initReveal();
    initNav();
    initGallery();
    initTabs();
    initPacks();
    initCart();
    initSticky();
    initResearchToggle();
    initReviews();
    initDrawerSync();
    initSparkles();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
